$(document).on("submit", "form[role='search']", function (e) {
  if (!$(this).children(".search__field").val().replace(/\s/g, "").length) {
    e.preventDefault();
  }
});
